var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Page',{attrs:{"title":_vm.pageTitle},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticClass:"flex flex-col max-w-7xl mx-auto my-10"},[_c('ReviewsList')],1)]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }